import React, { CSSProperties, ChangeEvent, memo } from "react";
import { Modal as MuiModal, TextField } from "@mui/material";
import styled from "styled-components";
import Box from "component/layoutComponents/Box/Box";
import Typography from "../../../Typography/Typography";
import { Theme } from "../../types";
import { Button } from "component/MarketPlace/ButtonComponents";

export const Field = styled(TextField)<{ theme: Theme }>(({ theme }) => ({
  ".MuiOutlinedInput-notchedOutline": {
    color: `${theme.uptimeColors.mainTheme.primary} !important`,
  },
  ".MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline": {
    borderColor: `${theme.uptimeColors.mainTheme.primary} !important`,
    borderWidth: "2px !important",
  },
  "label.Mui-focused": {
    color: `${theme.uptimeColors.mainTheme.primary} !important`,
  },
}));

export const ModalContainer = styled(Box)<{
  style?: CSSProperties;
  theme: Theme;
}>(({ theme }) => ({
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "400px",
  backgroundColor: theme.uptimeColors.grayScales.white,
  border: `2px solid #d9d9d9`,
  boxShadow: "24px",
  padding: "26px 24px",
  borderRadius: "8px",
  height: "220px",
}));

const Modal = ({
  openEditOrderDetailCard,
  costCenterCode,
  onCancelCostCenterCode,
  onChangeCostCenterCode,
  onUpdateCostCenterCode,
  locale
}: {
  openEditOrderDetailCard: boolean;
  costCenterCode: string;
  onCancelCostCenterCode: () => void;
  onChangeCostCenterCode: (e: ChangeEvent<HTMLInputElement>) => void;
  onUpdateCostCenterCode: () => void;
  locale?: any;
}) => {
  return (
    <>
      <MuiModal open={openEditOrderDetailCard} onClose={onCancelCostCenterCode}>
        <ModalContainer>
          <Typography paddingBottom="26px" fontWeight="600" fontSize="20px">
            {locale?.title}
          </Typography>
          <Field
            value={costCenterCode}
            onChange={onChangeCostCenterCode}
            label={locale?.placeholderInput}
            variant="outlined"
            fullWidth
          />
          <Box paddingTop="16px" display="flex" justifyContent="flex-end">
            <Button variant="text" onClick={onCancelCostCenterCode}>
              <Typography lineHeight="24px" fontWeight="600" fontSize="14px">
                {locale?.cancelButton}
              </Typography>
            </Button>
            <Button variant="text" onClick={onUpdateCostCenterCode}>
              <Typography lineHeight="24px" fontWeight="600" fontSize="14px">
                {locale?.useThisCodeButton}
              </Typography>
            </Button>
          </Box>
        </ModalContainer>
      </MuiModal>
    </>
  );
};

export default memo(Modal);
